import store from "redux/store";

class notificationService {

    async getNotificationsHistory() {
        return fetch(`${process.env.REACT_APP_NOTIFICATION_SERVICE_URL}/api/v2/events/history`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${store.getState().users.currentUser.data.accessToken}`
            }
        })
    }

    async sendNotification(data: any) {
        return fetch(`${process.env.REACT_APP_NOTIFICATION_SERVICE_URL}/api/v2/events/send`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${store.getState().users.currentUser.data.accessToken}`
            },
            body: JSON.stringify(data)
        })
    }

    async getNotificationsLastUpdatedDate(sellerId: number, accessToken: string) {
        return fetch(`${process.env.REACT_APP_LEGACY_APP_URL}/login/tasksUpdatedDate?auth=${accessToken}&sellerId=${sellerId}`)
    }

}

export default new notificationService();